module.exports = __webpack_public_path__ + "media/images/home/bursaries_icon_3-52f151be0096f3b5d189699dec375408.svg";